import React, { useState } from 'react';
import { Popup, List, Button, Grid, Divider } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SlideShow from '../SlideShow/SlideShow';
import _ from 'lodash';
import './TemplateItem.css';

const TemplateItem = props => {
  const { t } = useTranslation();
  let { width, height } = props.photo;
  const [open, setOpen] = useState(false);
  const srcSet = [props.photo.src];

  for (let i = 1; i < _.get(props.photo, 'data.pages', []).length; i++) {
    srcSet.push(
      `${process.env.REACT_APP_FILE_SERVER}/resources/templates/${props.photo.data.id}-${i + 1}/thumbnail.${
        props.photo.data.extension
      }`,
    );
  }

  if (height > 250) {
    width = (width * 250) / height;
    height = 250;
  }

  return (
    <div key={props.index} className="item-box" style={{ ...props.cont }}>
      <div className="template-image">
        {_.get(props.photo, 'data.price', 0) > 0 && <span className="proMark"></span>}
        <SlideShow
          alt={props.photo.title}
          style={{ ...props.imgStyle }}
          onClick={() => props.onClick(props.photo)}
          {...props.photo}
          width={width}
          height={height}
          srcSet={srcSet}
        />
        <div className="button-more transition">
          <Popup
            className="popup"
            on="click"
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            basic
            trigger={<Button icon="ellipsis horizontal" />}
          >
            <Popup.Content>
              <Grid>
                <Grid.Column floated="right">{_.get(props.photo, 'data.name', t('untitledDesign'))}</Grid.Column>
              </Grid>
              <Divider />
              <List relaxed verticalAlign="middle">
                <List.Item as="a" onClick={() => props.onClick(props.photo)}>
                  <List.Content>
                    <List.Header content={t('useTemplate')} />
                  </List.Content>
                </List.Item>
              </List>
            </Popup.Content>
          </Popup>
        </div>
      </div>
    </div>
  );
};

TemplateItem.propTypes = {
  index: PropTypes.number,
  photo: PropTypes.any,
  cont: PropTypes.any,
  imgStyle: PropTypes.any,
  onClick: PropTypes.func,
};

export default TemplateItem;
